module.exports = __webpack_public_path__ + "static/media/fernandez_adams-gore.52efb58f.jpg";